import qs from 'qs';
import type { ApplePayInitPayloadModel, ApplePayTokensModel } from '@/common/models/api.models';
import { PAYMENT_INIT_TIMEOUT_MS } from '../common/constants/paymentInit';

export function useKegelApplePayApi() {
  const STRIPE_BASE_URL = 'https://api.stripe.com/v1';

  class API_APPLE_PAY {
    public static async post(url: string, body: any, timeout?: number): Promise<any> {
      return await $fetch(`${STRIPE_BASE_URL}/${url}`, {
        method: 'POST',
        retry: 0,
        timeout,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json, text/plain, */*',
        },
        body: qs.stringify(body),
      });
    }
  }

  async function applePayInit(body: ApplePayInitPayloadModel): Promise<any> {
    return await API_APPLE_PAY.post('apple_pay/sessions', body, PAYMENT_INIT_TIMEOUT_MS);
  }

  async function sendTokens(body: ApplePayTokensModel): Promise<any> {
    return await API_APPLE_PAY.post('tokens', body);
  }

  return { applePayInit, sendTokens };
}
